import { Component, type ErrorInfo, type ReactNode } from 'react';

export class RootErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
    state: { error: Error | null } = { error: null };

    static getDerivedStateFromError(error: Error): { error: Error } {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('[REACT ERROR BOUNDARY]', { error, componentStack: info.componentStack });
    }
    render() {
        if (this.state.error) {
            return (
                <pre style={{ padding: 20, color: 'red' }}>
                    {String(this.state.error)}
                    {'\n'}
                    {this.state.error.stack ?? ''}
                </pre>
            );
        }
        return this.props.children;
    }
}
